import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ToolbarItem } from './ToolbarItem';
import { ChipGroup, Chip } from '../ChipGroup';
import { ToolbarContentContext, ToolbarContext } from './ToolbarUtils';
export var ToolbarFilter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToolbarFilter, _React$Component);

  function ToolbarFilter(props) {
    var _this;

    _classCallCheck(this, ToolbarFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToolbarFilter).call(this, props));
    _this.state = {
      isMounted: false
    };
    return _this;
  }

  _createClass(ToolbarFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          categoryName = _this$props.categoryName,
          chips = _this$props.chips;
      this.context.updateNumberFilters(typeof categoryName === 'string' ? categoryName : categoryName.name, chips.length);
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
          categoryName = _this$props2.categoryName,
          chips = _this$props2.chips;
      this.context.updateNumberFilters(typeof categoryName === 'string' ? categoryName : categoryName.name, chips.length);
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          chips = _a.chips,
          deleteChipGroup = _a.deleteChipGroup,
          deleteChip = _a.deleteChip,
          categoryName = _a.categoryName,
          showToolbarItem = _a.showToolbarItem,
          props = __rest(_a, ["children", "chips", "deleteChipGroup", "deleteChip", "categoryName", "showToolbarItem"]);

      var _this$context = this.context,
          isExpanded = _this$context.isExpanded,
          chipGroupContentRef = _this$context.chipGroupContentRef;
      var chipGroup = chips.length ? React.createElement(ToolbarItem, {
        variant: "chip-group"
      }, React.createElement(ChipGroup, {
        key: typeof categoryName === 'string' ? categoryName : categoryName.key,
        categoryName: typeof categoryName === 'string' ? categoryName : categoryName.name,
        isClosable: deleteChipGroup !== undefined,
        onClick: function onClick() {
          return deleteChipGroup(categoryName);
        }
      }, chips.map(function (chip) {
        return typeof chip === 'string' ? React.createElement(Chip, {
          key: chip,
          onClick: function onClick() {
            return deleteChip(categoryName, chip);
          }
        }, chip) : React.createElement(Chip, {
          key: chip.key,
          onClick: function onClick() {
            return deleteChip(categoryName, chip);
          }
        }, chip.node);
      }))) : null;

      if (!isExpanded && this.state.isMounted) {
        return React.createElement(React.Fragment, null, showToolbarItem && React.createElement(ToolbarItem, Object.assign({}, props), children), ReactDOM.createPortal(chipGroup, chipGroupContentRef.current.firstElementChild));
      }

      return React.createElement(ToolbarContentContext.Consumer, null, function (_ref) {
        var chipContainerRef = _ref.chipContainerRef;
        return React.createElement(React.Fragment, null, showToolbarItem && React.createElement(ToolbarItem, Object.assign({}, props), children), chipContainerRef.current && ReactDOM.createPortal(chipGroup, chipContainerRef.current));
      });
    }
  }]);

  return ToolbarFilter;
}(React.Component);
ToolbarFilter.contextType = ToolbarContext;
ToolbarFilter.defaultProps = {
  chips: [],
  showToolbarItem: true
};